import { ChangeEvent } from 'react'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { CvsAutoComplete } from '@components'
import { Search } from '@components/search'
import { useTemplatesWithFolderQuery } from '@global/hooks/queries/useTemplatesWithFolderQuery'
import * as css from './style'
import { t } from '@lingui/core/macro'

interface IAutoCompleteProps {
  onSelected: (item: string) => void
  selected: string | string[]
}

interface ISearchProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string
}

interface IPaginationProps {
  prevBtnDisabled: boolean
  nextBtnDisabled: boolean
  handlePaging: (btnClicked?: string) => void
}

interface IProps {
  templateSearchProps: IAutoCompleteProps
  paginationProps: IPaginationProps
  searchProps: ISearchProps
}

export const Toolbar = ({ templateSearchProps, searchProps, paginationProps }: IProps) => {
  const { onChange, defaultValue } = searchProps
  const { selected, onSelected } = templateSearchProps
  const { prevBtnDisabled, nextBtnDisabled, handlePaging } = paginationProps
  const [DATASETS_PAGE_ENABLED = false] = useSelector(
    selectFeatureIncludes([FeatureDict.DATASETS_PAGE]),
  )

  const { data: datasets = [], isInitialLoading: datasetsLoading } = useTemplatesWithFolderQuery({
    options: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 3600 * 1000, // 5 hours
      cacheTime: 10 * 3600 * 1000, // 10 hours
    },
  })

  const options = datasets.map(temp => ({
    value: temp.id,
    label: temp.name,
  }))

  return (
    <css.Toolbar>
      <Search onChange={onChange} defaultValue={defaultValue} />
      <CvsAutoComplete
        label={DATASETS_PAGE_ENABLED ? t`Dataset` : t`Template`}
        options={options as never[]}
        margin="dense"
        isClearable={Boolean(selected || false)}
        style={css.selectStyle}
        skin="white"
        selected={String(selected)}
        onSelected={onSelected}
        isLoading={datasetsLoading}
        allowMissingValueErrors={false}
      />
      <css.Pagination>
        <Button
          size="small"
          disabled={prevBtnDisabled}
          onClick={() => {
            handlePaging('previous')
          }}
        >
          <ChevronLeft />
          {t`Previous`}
        </Button>
        <Button
          size="small"
          disabled={nextBtnDisabled}
          onClick={() => {
            handlePaging()
          }}
        >
          {t`Next`}
          <ChevronRight />
        </Button>
      </css.Pagination>
    </css.Toolbar>
  )
}
